import React from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import _PodcastLibraryButtonAnchor from "PodcastLibraryButton-PodcastLibraryButtonAnchor.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PodcastLibraryButton.tsx?styleId=PodcastLibraryButtonAnchor";
import _IconContainer from "PodcastLibraryButton-IconContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/PodcastLibraryButton.tsx?styleId=IconContainer";


const PodcastLibraryButtonAnchor = /*#__PURE__*/styled("a", null, {
  displayName: "PodcastLibraryButtonAnchor",
  styles: _PodcastLibraryButtonAnchor
});

const IconContainer = /*#__PURE__*/styled("div", null, {
  displayName: "IconContainer",
  styles: _IconContainer
});

const PodcastLibraryButton = () => {
  return (
    <ImpressionWatcher source="podcast_library_nav_button">
      <PodcastLibraryButtonAnchor href="/podcast_library?trigger=podcast_library_nav">
        <IconContainer>
          <Icon name="books_movies_and_music" size={22} />
        </IconContainer>
        Podcast Library
      </PodcastLibraryButtonAnchor>
    </ImpressionWatcher>
  );
};

export default PodcastLibraryButton;
